import { GatewayAPIService } from '../../core/gateway-api.service';
import { SolutionDetails } from './solutionDetails';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SolutionService {
  options = { authenticate: true, setRoot: true, returnAsUrl: false };

  constructor(private api: GatewayAPIService) {}

  getById(id: string): Promise<SolutionDetails> {
    return this.api
      .apiCallSane(
        '/solution',
        'GET',
        this.api.getDefaultHeaders(),
        { id: id },
        null,
        this.options,
      )
      .then((d) => {
        return d;
      });
  }
}
